import { render } from "./contractslist.vue?vue&type=template&id=4d40e819"
import script from "./contractslist.vue?vue&type=script&lang=js"
export * from "./contractslist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__